export function handleTeamLogoImageLoad(teamIconRef) {
    const imageElement = teamIconRef.current;
    if (imageElement) {
        imageElement.style.visibility = "visible";
    }
}
//# sourceMappingURL=handleTeamLogoImageLoad.js.map